import React from "react";
import loadable from "../utils/loadable";
import Spinner from "../components/loaders/Spinner";

// Dashboard

export const Login = loadable(() => import("./Login"), {
  fallback: <Spinner />
});

export const NotFound = loadable(() => import("./NotFound"), {
  fallback: <Spinner />
});

export const CardDetail = loadable(
  () => import("./Dashboard/Cards/CardDetail"),
  {
    fallback: <Spinner />
  }
);

export const DashboardLanding = loadable(
  () => import("./Dashboard/DashboardLanding"),
  {
    fallback: <Spinner />
  }
);

export const Dashboard = loadable(() => import("./Dashboard"), {
  fallback: <Spinner />
});

export const Setting = loadable(() => import("./Setting"), {
  fallback: <Spinner />
});

export const Merchants = loadable(() => import("./Merchants"), {
  fallback: <Spinner />
});
export const MerchantTransaction = loadable(
  () => import("./MerchantTransaction"),
  {
    fallback: <Spinner />
  }
);
export const Transactions = loadable(() => import("./Transactions"), {
  fallback: <Spinner />
});
export const Wallet = loadable(() => import("./SystemWalletBalance"), {
  fallback: <Spinner />
});
export const PrivateRoute = loadable(() => import("./../PrivateRoute"), {
  fallback: <Spinner />
});
